import * as Yup from "yup";

export const SudentJoinClassSchema = Yup.object().shape({
  code: Yup.string()
    .min(5, "Le code saisi est trop court")
    .max(7, "Le code saisi est trop long")
    .required("Un code est requis"),
});

export const TeacherJoinClassSchema = Yup.object().shape({
  code: Yup.string()
    .min(5, "Le code saisi est trop court")
    .max(7, "Le code saisi est trop long")
    .required("Un code est requis"),
});
